import React from "react";
import pic1 from "../pic1.jpg"
import pic2 from "../pic2.jpg"
import pic3 from "../pic3.jpg"

const wrongParkingImages = [
  pic1, 
  pic3,
  pic2,
];

const WrongParkingGallery = () => {
  return (
    <div className="max-w-5xl mx-auto py-10 px-5">
      <h2 className="text-3xl font-bold text-center text-cyan-900 mb-6">
        Wrong Parking Examples
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {wrongParkingImages.map((image, index) => (
          <div key={index} className="overflow-hidden rounded-2xl shadow-lg">
            <img
              src={image}
              alt={`Wrong Parking Example ${index + 1}`}
              className="w-full h-60 object-cover hover:scale-105 transition-transform duration-300"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default WrongParkingGallery;
